import { ReactNode } from "react";

import { Stack } from "@mui/material";
import { StyledText } from "./StyledText";
import { TextStyle } from "../util/TextStyles";

export default function FormLabel({ icon, text, required, optional }: { icon?: ReactNode; text: string; required?: boolean; optional?: boolean }) {
  return (
    <Stack direction={"row"} style={{ gap: 8, alignItems: "center" }}>
      <div>{text}</div>
      <Stack style={{ flex: 1, alignItems: "end" }}>
        {required ? <StyledText textStyle="Required">必須</StyledText> : <></>}
        {optional ? <StyledText textStyle="Optional">任意</StyledText> : <></>}
      </Stack>
    </Stack>
  );
}
